import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-non-shield-footer',
    templateUrl: './non-shield-footer.component.html',
    styleUrls: ['./non-shield-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NonShieldFooterComponent implements OnInit {
    // Input properties
    @Input() app_footer_TAB_theme: string;
    @Input() showTabs: boolean;
    @Input() changeTabBg: boolean;
    @Input() currentPage: string;
    @Input() activateLeagueTheme: boolean;
     @Input() activateLeagueTheme2: boolean;
    @Input() replaceLeftTabsWtBtn: any;
    @Input() replaceRightTabsWtBtn: any;
    @Input() overdueActionCount: number;
    @Input() connectionState: boolean;
    @Input() isKeyboardOpen: boolean;
    @Input() isControllerOptionOpen: boolean;
    @Input() bottomPadding: string;
    @Input() bogTourButtonStatus: string;
    @Input() showCompassIcon: boolean;
    @Input() tripTimer: string;
    @Input() is_obs_screen: boolean;
    @Input() vpcHazService: any;
    @Input() currentTour: any;
    @Input() hasRnDRoleFn: () => boolean;
    @Input() getFooterTABBtnFn: () => string;
    @Input() getConversationtextFn: (key: string) => string;

    // Output events for click handlers
    @Output() homeClick = new EventEmitter<void>();
    @Output() actionMgmtClick = new EventEmitter<void>();
    @Output() performanceClick = new EventEmitter<void>();
    @Output() hamburgerClick = new EventEmitter<void>();
    @Output() checkStatusClick = new EventEmitter<void>();
    @Output() leftButtonClick = new EventEmitter<void>();
    @Output() rightButtonClick = new EventEmitter<void>();

    // FAB button events
    @Output() insideBogTourClick = new EventEmitter<void>();
    @Output() timerBogTourStartedClick = new EventEmitter<void>();
    @Output() moreUnderAreaClick = new EventEmitter<void>();
    @Output() bogTourNotStartedClick = new EventEmitter<void>();
    @Output() bogTourNotStartedAreaClick = new EventEmitter<void>();
    @Output() rapidTourNotStartedClick = new EventEmitter<void>();
    @Output() rapidTourNotStartedAreaClick = new EventEmitter<void>();
    @Output() insideRapidTourClick = new EventEmitter<void>();
    @Output() rapidTourStartedClick = new EventEmitter<void>();
    @Output() rapidTourStartedAreaClick = new EventEmitter<void>();
    @Output() openControllerOptions = new EventEmitter<void>();
    @Output() footerScannerBtn = new EventEmitter<string>();
    @Output() showMoreOption = new EventEmitter<void>();
    @Output() startBogTour = new EventEmitter<void>();
    @Output() zoneOption = new EventEmitter<void>();
    @Output() rapidOption = new EventEmitter<void>();
    @Output() openIntermediateOptions = new EventEmitter<void>();

    constructor() { }

    ngOnInit() { }

    // Methods to emit events
    onHomeClick() {
        this.homeClick.emit();
    }

    onActionMgmtClick() {
        this.actionMgmtClick.emit();
    }

    onPerformanceClick() {
        this.performanceClick.emit();
    }

    onHamburgerClick() {
        this.hamburgerClick.emit();
    }

    onCheckStatusClick() {
        this.checkStatusClick.emit();
    }

    onLeftButtonClick() {
        this.leftButtonClick.emit();
    }

    onRightButtonClick() {
        this.rightButtonClick.emit();
    }

    onInsideBogTourClick() {
        this.insideBogTourClick.emit();
    }

    onTimerBogTourStartedClick() {
        this.footerScannerBtn.emit('take-bog-tour');
    }

    onMoreUnderAreaClick() {
        this.showMoreOption.emit();
    }

    onBogTourNotStartedClick() {
        this.startBogTour.emit();
    }

    onBogTourNotStartedAreaClick() {
        this.showMoreOption.emit();
    }

    onRapidTourNotStartedClick() {
        this.openControllerOptions.emit();
    }

    onRapidTourNotStartedAreaClick() {
        this.showMoreOption.emit();
    }

    onInsideRapidTourClick() {
        this.insideRapidTourClick.emit();
    }

    onRapidTourStartedClick() {
        this.footerScannerBtn.emit('take-rapid-tour');
    }

    onRapidTourStartedAreaClick() {
        this.showMoreOption.emit();
    }

    onOpenControllerOptions() {
        this.openControllerOptions.emit();
    }

    onFooterScannerBtn(mode: string) {
        this.footerScannerBtn.emit(mode);
    }

    onShowMoreOption() {
        this.showMoreOption.emit();
    }

    onStartBogTour() {
        this.startBogTour.emit();
    }

    getFooterTABBtn(): string {
        return this.getFooterTABBtnFn ? this.getFooterTABBtnFn() : '';
    }

    getConversationtext(key: string): string {
        return this.getConversationtextFn ? this.getConversationtextFn(key) : '';
    }

    hasRnDRole(): boolean {
        return this.hasRnDRoleFn ? this.hasRnDRoleFn() : false;
    }

    onZoneOption() {
        this.zoneOption.emit();
    }

    onRapidOption() {
        this.rapidOption.emit();
    }

    onOpenIntermediateOptions() {
        this.openIntermediateOptions.emit();
    }
}

